<template>
	<div class="profile-wrapper">
		<div v-if="show" id="supplier-column" class="profile-column">
			<div
				v-for="(profile, index) in supplierProfiles"
				class="profile-card"
				@click="$emit('checkProfileExistence', profile.type)"
				v-show="profile.visible"
				:key="index"
			>
				<div class="card blue darken-2">
					<div class="card-content white-text">
						<span class="card-title center-align">{{
							profile.title
						}}</span>
						<font-awesome-icon
							:icon="['fas', profile.icon]"
							class="center-icon font-awesome-icon"
						/>
						<p class="center-align">
							{{ profile.description }}
						</p>
					</div>
				</div>
			</div>
		</div>
		<div v-else id="contractor-column" class="profile-column">
			<div
				v-for="(profile, index) in contractorProfiles"
				class="profile-card"
				@click="$emit('checkProfileExistence', profile.type)"
				v-show="profile.visible"
				:key="index"
			>
				<div class="card blue darken-2">
					<div class="card-content white-text">
						<span class="card-title center-align">{{
							profile.title
						}}</span>
						<font-awesome-icon
							:icon="['fas', profile.icon]"
							class="center-icon font-awesome-icon"
						/>
						<p class="center-align">
							{{ profile.description }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'MenuBtn',
    props: {
        contractorProfiles: {
            type: Array,
            default: () => [],
        },
        supplierProfiles: {
            type: Array,
            default: () => [],
        },
        show: Boolean,
    },
};
</script>

<style>
.font-awesome-icon {
	display: block !important;
	font-size: 47px !important;
	max-height: 57px !important;
	min-height: 57px !important;
}
.center-icon {
	margin-left: 45%;
}
.opacity {
	opacity: 0.3;
}

.profile-wrapper {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
}
.profile-column {
	flex-direction: column;
}
.profile-card {
	cursor: pointer;
	flex: 0 calc(50% - 40px);
	margin: 12px 16px;
	width: 450px;
}
.card {
	height: fit-content;
}

.row.section {
	margin-top: 0px;
	padding-top: 15px;
}

.card .card-content {
	padding: 14px;
}
.card .card-content .card-title {
	font-size: 22px;
}

@media screen and (max-width: 992px) {
	.profile-card {
		width: 350px;
	}
}
</style>
